/**
 * Revinate API Integration for Contact Form 7
 *
 * Listens for CF7's `wpcf7mailsent` event (which only fires after CF7
 * validates the submission, runs all wpcf7_spam filters incl. honeypot +
 * reCAPTCHA v3, and dispatches mail), then hands the form off to Revinate's
 * official library to POST the contact.
 *
 * @package AwasiTwentyfive
 */

const REVINATE_FORM_ID = 'revinate_contact_api_form';
const REVINATE_FIELD_NAMES = new Set([
	'DATEOFSTAY',
	'LODGEVISITED',
	'REFERRALEMAIL',
	'REFERRALNAME',
	'email',
	'field-email',
	'firstName',
]);

/**
 * Revinate expects a form with a fixed id. Build a temporary surrogate form so
 * real CF7 forms never share that id or leak CF7 internals into the payload.
 */
function createRevinateForm(token) {
	const form = document.createElement('form');
	form.id = REVINATE_FORM_ID;
	form.setAttribute('token', token);
	form.hidden = true;

	const submitButton = document.createElement('button');
	submitButton.type = 'submit';
	form.appendChild(submitButton);

	return form;
}

function getRevinateFieldName(field) {
	if (field.name === 'field-email') {
		return 'email';
	}

	return field.name;
}

function shouldCopyField(field) {
	if (!REVINATE_FIELD_NAMES.has(field.name)) return false;
	if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return false;
	if (field.value === '') return false;
	return true;
}

function appendPayloadField(form, name, value) {
	const field = document.createElement('input');
	field.type = 'hidden';
	field.name = name;
	field.value = value;
	form.appendChild(field);
}

function pushToRevinate(form) {
	const tokenField = form.querySelector('[name="field-token"]');
	const emailField = form.querySelector('[name="field-email"], [name="email"]');
	if (!tokenField?.value || !emailField?.value) return;
	if (typeof revFormOnSubmit !== 'function') return;

	const revinateForm = createRevinateForm(tokenField.value);
	const fields = Array.from(form.querySelectorAll('input, select, textarea'));

	fields
		.filter(shouldCopyField)
		.forEach((field) => {
			appendPayloadField(revinateForm, getRevinateFieldName(field), field.value);
		});

	try {
		document.body.appendChild(revinateForm);
		revFormOnSubmit();
	} catch (err) {
		console.error('Revinate submission error:', err);
	} finally {
		revinateForm.remove();
	}
}

document.addEventListener('wpcf7mailsent', (event) => {
	const form = event.target;
	if (!(form instanceof HTMLFormElement)) return;
	if (!form.querySelector('[name="field-token"]')) return;
	pushToRevinate(form);
});
